import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {ClientOwnersModel} from "./client-owners.model";
import {ClientLocationsModel} from "../client-locations/client-locations.model";

@Injectable()
export class ClientOwnersService implements IDataModel {

    private API_ROOT:string = '/clients/owners';

    constructor(private http:Http) {
    }

    getList(filter:IDataFilter): Observable<ListResponseModel<ClientOwnersModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<ClientOwnersModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/owners`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getOne(id:number):Observable<ResponseModel<ClientOwnersModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:ClientOwnersModel): Observable<ResponseModel<ClientOwnersModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:ClientOwnersModel): Observable<ResponseModel<ClientOwnersModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    saveList(clientId:number, owners: ClientOwnersModel[]): Observable<ListResponseModel<ClientOwnersModel>> {
        return this.http.put(`/clients/${clientId}/owners`, owners)
            .map((res) => {
                let response: ListResponseModel<ClientOwnersModel> = res.json();

                response.data.forEach(function (val) {
                    val.home_location = val.home_location || new ClientLocationsModel(); // todo
                });

                return response;
            });
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/client-owners/client-owners.service.ts